import React, { useState, useContext } from "react";
import LoaderAnimation from "./LoaderAnimation";
import { useNavigationEvent } from "navigation-react";
// import loginImage from "./images/bg-leaves.jpg";
import mainLogo from "./images/mainlogo.png";
import "./styles.css";
import SecureLS from "secure-ls";
import { RoleContext } from "./App"; // ✅ Import RoleContext

const ls = new SecureLS({ encodingType: "aes" });

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [cookieWarning, setCookieWarning] = useState("");
  const { stateNavigator } = useNavigationEvent();

  // ✅ Correctly destructure setRoles from context
  const { setRoles } = useContext(RoleContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      alert("Please enter your credentials");
      return;
    }

    setLoading(true);
    setCookieWarning("");

    try {
      // 1️⃣ Login
      const loginUrl = `${process.env.REACT_APP_BASE_URL}/user/login?_format=json`;
      const loginResponse = await fetch(loginUrl, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ name: username, pass: password }),
      });

      if (!loginResponse.ok) {
        const errJson = await loginResponse.json().catch(() => ({}));
        alert("Login failed. Please check your credentials.", errJson.message);
        setLoading(false);
        return;
      }

      const loginData = await loginResponse.json();

      // Store user info in SecureLS
      ls.set("username", loginData.current_user.name);
      ls.set("currentuserid", loginData.current_user.uid);
      ls.set("currentuserrole", loginData.current_user.roles);
      ls.set("userlogout_token", loginData.logout_token);

      // ✅ Update RoleContext immediately
      setRoles(loginData.current_user.roles);

      // 2️⃣ Get CSRF token
      const csrfRes = await fetch(
        `${process.env.REACT_APP_BASE_URL}/session/token`,
        {
          method: "GET",
          credentials: "include",
          headers: { Accept: "application/json" },
        }
      );
      const csrfToken = await csrfRes.text();
      ls.set("usercsrf_token", csrfToken);

      // 4️⃣ Fetch permissions
      const permUrl = `${process.env.REACT_APP_BASE_URL}/api/user/permissions`;
      const permRes = await fetch(permUrl, {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": csrfToken,
        },
      });

      if (!permRes.ok) {
        const text = await permRes.text();
        alert(`Failed to load permissions (status ${permRes.status}): ${text}`);
        return;
      }

      const permissions = await permRes.json();
      ls.set("permissions", permissions);

      alert("Login successful");
      stateNavigator.navigate("dashboardcontent");
    } catch (error) {
      console.error("❌ Login Error:", error);
      alert(`Error: ${error.message}`);
    }
  };

  if (loading) return <LoaderAnimation />;

  return (
    <div className="modern-login-page">
      <div className="modern-login-card">
        <div className="login-logo">
          <img src={mainLogo} alt="Logo" />
          <h2>POINT OF SALE</h2>
        </div>

        {cookieWarning && (
          <div
            className="cookie-warning"
            style={{ color: "red", marginBottom: "10px" }}
          >
            {cookieWarning}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          {/* <h3>Welcome back 👋</h3> */}
          <p className="login-subtext">
            Please sign in to access your dashboard
          </p>

          <div className="input-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="modern-login-btn" disabled={loading}>
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>

        <footer className="login-footer">
          <p>
            © {new Date().getFullYear()} Reactive Developers. Contact:
            0257335982
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Login;
